import {Button, GoogleExtensionIcon} from '@blesk-frontend/ui';
import {AppPageWrapper} from '@/components';
import {useAppPlatform} from '@/hooks';
import {downloadAgent} from '@/libs';

export const ExtensionPage = () => {
  const {extensionStatus} = useAppPlatform();
  const isNotAvailable = extensionStatus === 'not-available';

  const onClickDownload = () => {
    if (isNotAvailable) return;

    downloadAgent('chrome');
  };

  return (
    <AppPageWrapper>
      <div className="mx-auto max-w-lg p-4">
        <div className="flex flex-col gap-8">
          <div className="flex flex-col items-center gap-6">
            <GoogleExtensionIcon />
            <h1 className="text-center text-title-h1">
              Установите расширение
              <br />
              для браузера
            </h1>
            <p className="text-center text-paragraph-md text-text-secondary">
              Чтобы записывать действия на сайтах и&nbsp;автоматически создавать пошаговые
              инструкции, вам необходимо установить расширение для&nbsp;браузера.
            </p>
            <p className="text-center text-paragraph-md text-text-secondary">
              Например для Битрикс24, Мой Склад, Jira и др.
            </p>
            <div className="flex flex-col items-center">
              <Button onClick={onClickDownload} disabled={isNotAvailable}>
                Установить Блеск для браузера
              </Button>
            </div>

            <p className="text-center text-paragraph-md text-text-secondary">
              Работает в Chrome, Edge, Opera
            </p>
          </div>
        </div>
      </div>
    </AppPageWrapper>
  );
};
